import styled from "styled-components";
import media from "constants/media";

export const ValueInputStyled = styled.div`
    width: 100%;
    overflow: auto;

    ${media.smUp`
        max-width: 360px;
        margin-left: auto;

    `}
`;
export const Label = styled.label`
    color: var(--color-darkNight);
    font-weight: 600;
    font-size: 16px;
    font-family: var(--font-DINPro);
    line-height: 25px;
    letter-spacing: 0;
`;

export const Info = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 16px;
`;

export const Text = styled.span`
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0;

    ${media.mdUp`
        font-size: 15px;
        line-height: 25px;
    `}
`;

export const InputContainer = styled.div`
    position: relative;
    z-index: 1;

    margin-bottom: 30px;

    > div {
        margin-bottom: 0;
    }
`;
